document.addEventListener("DOMContentLoaded", function () {
  // Dropdown for announcement country list
  const trigger = document.querySelector('[aria-controls="AnnouncementCountryList"]');
  const dropdown = document.getElementById("AnnouncementCountryList");
  if (trigger && dropdown) {
    let isOpen = false;
    trigger.addEventListener("click", function (event) {
      event.stopPropagation();
      if (!isOpen) {
        if (!dropdown.dataset.moved) {
          document.body.appendChild(dropdown);
          dropdown.dataset.moved = "true";
          const scrollWrapper = document.createElement("div");
          scrollWrapper.classList.add("scroll-wrapper");
          while (dropdown.firstChild) scrollWrapper.appendChild(dropdown.firstChild);
          dropdown.appendChild(scrollWrapper);
        }
        const rect = trigger.getBoundingClientRect();
        dropdown.style.position = "absolute";
        dropdown.style.zIndex = "99999";
        dropdown.style.top = window.scrollY + rect.bottom + "px";
        dropdown.style.left = window.scrollX + rect.left + "px";
        dropdown.style.display = "block";
        dropdown.removeAttribute("hidden");
        isOpen = true;
      } else {
        dropdown.setAttribute("hidden", "");
        dropdown.style.display = "none";
        isOpen = false;
      }
    });
    document.addEventListener("click", function (event) {
      if (isOpen && !dropdown.contains(event.target) && !trigger.contains(event.target)) {
        dropdown.setAttribute("hidden", "");
        dropdown.style.display = "none";
        isOpen = false;
      }
    });
  }
  // Set CSS variable for header height
  const header = document.getElementById("header-wrapper");
  if (header) {
    document.documentElement.style.setProperty("--header-height", header.offsetHeight + "px");
  }
  // Fade-in animations
  document.querySelector(".menu-fade")?.classList.add("visible");
  document.querySelector(".homepage-fade-in")?.classList.add("visible");
  document.querySelector(".page-fade-in")?.classList.add("visible");
  // Replace no-js class
  document.documentElement.className =
    document.documentElement.className.replace("no-js", "js");
});

// REMOVED 2026-07-18: a second DOMContentLoaded block that lazy-loaded cart-upsell.js on
// the `cart:open` event. It built the URL as `script.src = '{{ "cart-upsell.js" | asset_url }}'`
// -- a Liquid tag inside a .js file. Liquid does not render in .js assets, so the tag was
// served verbatim; every cart-drawer open fetched a bogus relative URL and 404'd. That was
// the "Browser errors were logged to the console" PageSpeed/Lighthouse audit failure.
//
// The script was redundant regardless: the cart-drawer upsell is fully driven by custom.js
// ($(document).ready -> `if ($("[data-cart-upsell-carousel]").length > 0)`), which inits the
// Slick carousel, wires the prev/next arrows and progress bar, and adds `is-hidden` (0 items)
// / `is-single-product` (1 item). Loading cart-upsell.js on top would have re-init'd Slick on
// an already-initialized carousel. assets/cart-upsell.js and sections/cart-upsell.liquid are
// now dead code and can be deleted separately.
